export default "__VITE_ASSET__4d7f831a__"